"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Logo = require("../Logo");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Logo = (0, _styledComponents.default)(_Logo.Logo)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0px;\n  max-width: 150px;\n"])));
exports.Logo = Logo;